import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const STOCK_BASE = "/importorders";
const buildUrl = (endpoint) => STOCK_BASE + endpoint;
const API_TAG = "ImportOrders";

const importOrderApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getImportOrders: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getImportOrders', API_TAG),
        }),
        syncImportOrder: builder.mutation({
            query: syncBody => ({
                url: buildUrl(`/${syncBody.id}/sync`),
                method: 'PUT',
                body: syncBody,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }],
        }),
        getImportOrderWebshopJson: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/webshopjson`),
                method: 'GET',
            }),
            // Always ask the webshop again when the modal reopens
            keepUnusedDataFor: 0,
        }),
        deleteImportOrder: builder.mutation({
            query: syncBody => ({
                url: buildUrl(`/${syncBody.id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }],
        }),
        bulkDeleteImportOrders: builder.mutation({
            query: bulkObject => ({
                url: buildUrl(`/bulkdelete`),
                method: 'POST',
                body: bulkObject,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }],
        }),
    })
});

export const { 
    useGetImportOrdersQuery,
    useSyncImportOrderMutation,
    useGetImportOrderWebshopJsonQuery,
    useDeleteImportOrderMutation,
    useBulkDeleteImportOrdersMutation
} = importOrderApiSlice;
